import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import JobsTable from './jobs-table.jsx';


if (document.getElementById('react-component-g4-logistics-portal-parent-jobs')) {
  ReactDOM.render(<JobsTable
    url= "/api/v1/portal/jobs/parent"
    infiniteScroll={true}
    message_if_none = 'No parent jobs yet.'
  />,
document.getElementById('react-component-g4-logistics-portal-parent-jobs'));
}
